import { ILocation } from '@ddot/AddToCartCommon/lib/entities';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { AsyncThunkAPI } from 'Redux/types';
import Atc from '../../../../Lib/ATC';

export default createAsyncThunk<
    ILocation[],
    void,
    AsyncThunkAPI
>('home/getLocation', async (params, thunkAPI) => {
    const response = await thunkAPI.extra.useCases.location.getLocation.execute();

    if (response.status === Atc.UseCases.Types.UseCaseResponseStatus.Success) {
        return response.data;
    }

    return thunkAPI.rejectWithValue(response.data.message || 'Something went wrong. Please try again.');
});
